<template>

    <div class="row">
        <div class="col-sm-8 col-sm-offset-2">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Actieve teams</h2>
                    <div class="box-tools">
                        <router-link
                            class="btn btn-primary btn-xs"
                            :to="{name:'hr.teams.add'}"
                            v-tooltip.bottom="'Team toevoegen'"
                        >
                            <i class="mdi mdi-plus"></i>
                            <span class="sr-only">Team toevoegen</span>
                        </router-link>
                        <button
                            v-if="trashCount > 0"
                            class="btn btn-xs"
                            type="button"
                            @click="$refs.HrTeamsTrashcanModal.openModal()"
                            v-tooltip.bottom="'Prullenbak ('+trashCount+')'"
                        >
                            <i class="mdi mdi-delete"></i>
                            <span class="sr-only">Prullenbak ({{ trashCount }})</span>
                        </button>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th style="width:100px"># leden</th>
                                <th style="width:75px">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="teams.length === 0">
                                <td colspan="3">Er zijn geen teams gevonden</td>
                            </tr>
                            <tr v-for="team in teams" :id="'team-' + team.id">
                                <td>
                                    {{ team.name }}
                                </td>
                                <td>
                                    {{ team.users_count }}
                                </td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-xs">
                                        <router-link
                                            class="btn btn-primary"
                                            :to="{name:'hr.teams.edit',params:{id:team.id}}"
                                            v-tooltip="'Team bewerken'"
                                        >
                                            <i class="mdi mdi-pencil"></i>
                                        </router-link>
                                        <button
                                            class="btn btn-danger btn-xs"
                                            @click="deleteTeam(team.id)"
                                            v-tooltip="'Team verwijderen'"
                                            :disabled="team.users_count>0"
                                        >
                                            <i class="mdi mdi-delete"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>
        </div>
        <hr-teams-trashcan-modal
            v-if="!loading"
            :trashed-teams="trashedTeams"
            ref="HrTeamsTrashcanModal"
            @hidden="reloadData"
        ></hr-teams-trashcan-modal>
    </div>

</template>

<script>

    import axios from 'axios';
    import HrTeamsTrashcanModal from "./TrashcanModal";

    export default {

        components: {
            HrTeamsTrashcanModal,
        },

        data() {
            return {
                teams:[],
                trashedTeams:[],
                loading:true,
                trashCount:0,
            }
        },

        methods: {
            getTeams() {
                axios.get(this.route('api.v1.hr.teams.index'))
                    .then(resp => {
                        this.teams = resp.data.data;
                        this.loading = false;
                    })
                    .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de teams'));
            },

            getTrashedTeams() {
                axios.get(this.route('api.v1.hr.teams.trashcan'))
                    .then(resp => {
                        this.trashedTeams = resp.data.data;
                        this.trashCount = resp.data.data.length;
                    })
                    .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de prullenbak'));
            },

            deleteTeam(team_id) {
                axios.delete(this.route('api.v1.hr.teams.destroy', {id: team_id}))
                    .then(resp => {
                        if (resp.data.success) {
                            this.reloadData();
                            this.$snotify.success('Het team is verwijderd.');
                        } else {
                            this.$snotify.error('Er is een fout opgetreden bij het verwijderen van het team.');
                        }
                    });
            },

            loadData() {
                this.getTeams();
                this.getTrashedTeams();
            },

            reloadData() {
                this.loadData();
                this.$forceUpdate();
            }
        },

        mounted() {
            this.loadData();
        },

        name:'HrTeamsIndex',

    }

</script>
